<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/BaseInfo">
				用户中心
				<span class="plr5">/</span>
			</router-link>
			<router-link class="col04" to="/Order">
				我的订单
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">订单详情</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="1" :secondIndex="-1"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="fs22 col90 fwb">上传试用报告</div>
				<upLoad @fileSuc="onUpload" accept=".zip,.rar,.gzip,.gz">
					<div class="up_box">
						<!-- <img :src="reportPic?'../../../assets/static/icon/report_icon.png':''" v-if="reportPic !== ''" alt="" class="reportPic"> -->
						<div class="flex-box flex-center zip_box" v-if="reportPic">
							<img src="../../../assets/static/icon/report_icon.png" alt="" />
						</div>
						<div class="up flex-box flex-center flex-col fs16 cold3" v-else>点击上传试用报告压缩包</div>
					</div>
				</upLoad>
				<div class="flex-box flex-end">
					<div class="foot_btn resend flex-box flex-center fs20 fwb" @click="onCancel">取消上传</div>
					<div class="foot_btn sure fs20 fwb" @click="onSave">确认上传</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import upLoad from "../../../components/Upload.vue";
	import PersonalNav from "../../../components/PersonalNav.vue";
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "试用报告-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		components: {
			PersonalNav,
			upLoad,
		},
		data() {
			return {
				orderSn: 0,
				reportPic: "",
				fileSize: 0,
				fileName: ''
			};
		},
		created() {
			const orderSn = this.$route.query.order_sn;
			if (orderSn) {
				this.orderSn = orderSn;
			} else {
				this.$message.error("未接收到有效的订单编号");
			}
		},
		methods: {
			onUpload(e) {
				this.fileName = e.file_name;
				this.fileSize = e.file_size;
				this.reportPic = e.url;
			},
			onCancel() {
				this.$router.go(-1);
			},
			onSave() {
				let page = this;
				if (!page.reportPic) {
					page.$message.error("请上传报告");
					return;
				}
				this.$confirm("确定要上传报告？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.OrderReport({ order_sn: page.orderSn, report_file: page.reportPic,file_name: page.fileName,file_size: this.fileSize}).then((ret) => {
						page.$message.success("上传成功");
						page.$router.go(-1);
					});
				});
			},
		},
	};
</script>
<style>
	.el-upload.el-upload--picture-card {
		width: 100%;
	}
</style>
<style lang="less" scoped>
	.part_r {
		background: #fff;
		padding: 41px 44px;

		.up_box {
            width: 100%;
			height: 500px;
			background: #fbfcfd;
			border-radius: 8px;
			border: 2px solid rgba(98, 134, 171, 0.2);
			margin: 24px 0;
			overflow: hidden;

			.zip_box {
				width: 100%;
				height: 500px;

				img {
					width: 88px;
					height: 88px;
					display: block;
				}
			}

			.up {
				width: 100%;
				height: 100%;
			}

			.up::before {
				content: "";
				display: block;
				width: 66px;
				height: 60px;
				background: url("../../../assets/static/icon/c_add_up.png") no-repeat center;
				background-size: 100%;
				margin-bottom: 14px;
			}
		}

		.foot_btn {
			width: 228px;
			height: 60px;
			border-radius: 6px;
			border: 2px solid #d2d2d2;
			color: #434343;
			line-height: 56px;
			text-align: center;
			margin-left: 24px;
			cursor: pointer;

			&.sure {
				border-radius: 6px;
				background: #1275ff;
				border-color: #1275ff;
				color: #fff;
			}

			&.resend {
				color: #1275ff;
			}
		}
	}
</style>
